import React, { useEffect, useState } from "react";
import classes from "./index.module.css";
import {
  Typography,
  TextField,
  InputAdornment,
  Card,
  CardContent,
} from "@mui/material";
import { Box } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  DatePickerCalendarIcon,
  SearchIcon,
} from "../../../components/Icons";
import moment from "moment";

const FilterContainer = ({
  dateObject,
  selectedDate,
  teamMembers,
  onSelectMember,
}) => {
  const [serachValue, setSearchValue] = useState("");
  const [selectedValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    if (selectedDate != null) {
      const formattedNew = moment(selectedDate).format("YYYY-MM-DD");
      const formattedCurrent = date ? moment(date).format("YYYY-MM-DD") : null;
      if (formattedNew !== formattedCurrent) {
        setDate(selectedDate);
      }
    }
  }, [selectedDate]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (date !== undefined) {
      dateObject(date, serachValue, selectedValues);
    }
  }, [date, serachValue, selectedValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSearchValue = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    dateObject(date, value, selectedValues);

    if (value.trim() && teamMembers?.length > 0) {
      const filtered = teamMembers.filter((m) =>
        m.name.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleSelectSuggestion = (member) => {
    onSelectMember(member);
    setSearchValue(member.name);
    setShowSuggestions(false);
  };

  return (
    <div className={`${classes.MapFiltersContainer}`}>
      {!window.location.pathname.includes("view-route") && (
        <div style={{ position: "relative" }}>
          <div>
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              placeholder="search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              className={classes.teamMemberSearch}
              id="firstNameinput"
              value={serachValue}
              onChange={(e) => handleSearchValue(e)}
              onFocus={() => {
                if (serachValue.trim() && suggestions.length > 0) {
                  setShowSuggestions(true);
                }
              }}
              onBlur={() => {
                setTimeout(() => setShowSuggestions(false), 200);
              }}
              size="small"
              autoComplete="off"
            />
          </div>
          {showSuggestions && suggestions.length > 0 && (
            <Card className={classes.suggestionsContainer}>
              <CardContent className={classes.suggestionsContent}>
                {suggestions.map((member, index) => (
                  <div
                    key={index}
                    className={classes.suggestionItem}
                    onClick={() => handleSelectSuggestion(member)}
                  >
                    <Typography variant="body2">{member.name}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {member.team_name || "No Team"}
                    </Typography>
                  </div>
                ))}
              </CardContent>
            </Card>
          )}
        </div>
      )}
      <div
        style={{
          display: "flex",
          columnGap: 20,
          alignItems: "center",
          width: "100%",
          justifyContent: "flex-end",
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ minWidth: 200 }}>
            <DesktopDatePicker
              sx={{ width: '100%', '& .MuiInputBase-root': { height: 40, background: 'white' } }}
              value={date ? dayjs(date) : null}
              onChange={(newValue) => setDate(newValue?.toDate())}
              format="YYYY-MM-DD"
              slots={{ openPickerIcon: DatePickerCalendarIcon }}
            />
          </Box>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export default FilterContainer;
